import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(home)/blog/page.tsx");
